export function isTest() {
    try {
        return import.meta.env.MODE === "test";
    }
    catch { }
    return false;
}
export function isPreprodOrLocal(hostname = readHostname()) {
    if (hostname.includes("prod.localhost"))
        return false;
    return (hostname.includes("localhost") ||
        hostname.includes("127.0.0.1") ||
        hostname.includes("localtest.me") ||
        hostname.includes("tempdev") ||
        hostname.includes("temp-app.dev.evidenceb") ||
        hostname.includes("preprod"));
}
function readImportMetaEnv() {
    try {
        return { MODE: import.meta.env.MODE, DEV: import.meta.env.DEV };
    }
    catch {
        return {};
    }
}
function readHostname() {
    try {
        return window.location.hostname.toLowerCase();
    }
    catch {
        return "";
    }
}
/**
 * Whether RxDB's dev-mode plugin should be registered. Dev-mode adds schema
 * validation AND injects a (visible) marketing iframe into <body>
 * (rxdb/plugins/dev-mode `addDevModeTrackingIframe`), which breaks the
 * player/auth/dashboard e2e tests — so it must be off anywhere production-like.
 *
 * Enabled: the local dev server (`vite`, where import.meta.env.DEV is true — this
 * also keeps it on under vitest unit tests) and the tempdev branch-preview hosts.
 * Disabled: production, preprod, and the e2e suite.
 *
 */
export function shouldEnableRxdbDevMode(env = readImportMetaEnv(), hostname = readHostname()) {
    if (env.MODE === "e2e")
        return false;
    if (env.DEV)
        return true;
    return (hostname.includes("tempdev") || hostname.includes("temp-app.dev.evidenceb"));
}
//# sourceMappingURL=envCheck.js.map